export default __webpack_public_path__ + "static/gearsPop-f557589dc67ff78ccb5a5a98a8793953.jpg";